export class DadosAlteracaoSenhaModel {

    public cpf: string;
    public guid: string;
    public senha: string;
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-alterar-senha/dados-alteracao-senha-model.ts